import { getCookie } from "./functions/Helper";
import { addData } from "./API";
import { UTM_COOKIE, saveUtmCookie } from "./utmStorage";

export { getStoredUTM, getUtmTrackingId, clearUtmCookie } from "./utmStorage";


const registerVisit = async (utm) => {
  try {
    const response = await addData("api/v1/utm", utm);
    const trackingId = response?.data?.data?.utmTrackingId;
    if (trackingId) {
      saveUtmCookie({ ...utm, trackingId });
    }
  } catch (e) {
  }
};


export const captureUTM = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.get("utm_source") && !params.get("utm_campaign")) return;
    if (getCookie(UTM_COOKIE)) return;
    if (localStorage.getItem("session")) return;

    const utm = {
      source: params.get("utm_source"),
      medium: params.get("utm_medium"),
      campaign: params.get("utm_campaign"),
      content: params.get("utm_content"),
      term: params.get("utm_term"),
      // Extra attribution params from the doc: utm_id, affiliate ref, external click id.
      utmId: params.get("utm_id"),
      affiliateRef: params.get("ref"),
      clickId: params.get("click_id"),
      // Landing page without the query string (the utm params are stored separately).
      landingUrl: window.location.origin + window.location.pathname,
    };
    saveUtmCookie(utm);
    if (getCookie(UTM_COOKIE)) {
      registerVisit(utm);
    }
  } catch (e) {
  }
};
